import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { GalleryAction } from '@textbook-api-client';

import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../external/providers/textbook-actions-handler';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import { GroupInfo } from '../../models/group-info';
import { map, Observable, of } from 'rxjs';
import { ActionDrawerApi } from "../@base/models/action-drawer-api";

@Component({
  selector: 'txtb-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GalleryComponent extends TextbookActionBase<GalleryAction> implements OnChanges {
  @Input() groupInfo!: GroupInfo;
  indexShown = false;
  galleryLength = 0;
  activeElement = 1;
  images: GalleryAction['meta']['images'] = [];
  actionContentCollapsed = false;
  minimizeArrowVisible = true;
  private actionDrawerApi?: ActionDrawerApi;

  constructor(
    @Inject(TextbookActionsHandlerToken)
    public textbookActionsHandler: TextbookActionsHandler,
    public ref: ChangeDetectorRef
  ) {
    super();
  }

  imageSrc: string[] = [];
  imageSrc$(resourceId: string, index: number): Observable<void> {
    if (this.imageSrc[index]) {
      return of(undefined);
    }
    return this.textbookActionsHandler.getResourceBlobAsString(resourceId).pipe(
      map((src) => {
        this.imageSrc[index] = src;
      })
    );
  }

  changeElement(e: number): void {
    this.activeElement = e;
    setTimeout(() => this.collapse(false), 200);
    this.actionDrawerApi?.resetZoom();
  }

  onActionDrawerApiInitialized(service: ActionDrawerApi): void {
    this.actionDrawerApi = service;
  }

  contentCollapse(state: boolean): void {
    this.actionContentCollapsed = state;
  }

  collapse(state: boolean): void {
    this.actionContentCollapsed = state;
    this.ref.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('action' in changes) {
      const imagesData = changes.action.currentValue?.meta?.images ?? [];
      this.images = [...imagesData];
      this.galleryLength = this.images.length;
    }
  }

  showAll(): void {
    this.indexShown = true;
    this.minimizeArrowVisible = false;
    setTimeout(() => this.collapse(false), 200);
    this.actionDrawerApi?.resetZoom();
    this.actionDrawerApi?.disableZoom();
  }

  showFullImg(index: number): void {
    this.minimizeArrowVisible = true;
    setTimeout(() => this.collapse(false), 200);
    this.activeElement = index;
    this.indexShown = false;
    this.actionDrawerApi?.enableZoom();
  }
}
